/**
 * @private
 * Using two arrays, merge the second array into the slots of the first array which are undefined
 */
export function mergeIntoUndefinedSlots(intoArr = [], fromArr = []) {
	let startIndex = 0;
	if (fromArr.length === 0) {
		return intoArr.filter((elem) => typeof elem !== 'undefined');
	}
	return intoArr
		.map((elem) => {
			if (typeof elem === 'undefined') {
				return fromArr[startIndex++];
			}

			return elem;
		})
		.filter((elem) => typeof elem !== 'undefined');
}

/**
 * @private
 * Massage response data from a request into an object with data for each symbol,
 * namespaced by the symbol requested
 */
export function keyResponseDataBySymbol(symbols=[], response) {
	return symbols.reduce((dataBySymbol, nextSymbol, symbolIdx) => {
		dataBySymbol[nextSymbol] = response.columns.reduce((symbolData, fieldName, fieldIdx) => {
			symbolData[fieldName] = response.rows[symbolIdx][fieldIdx];
			return symbolData;
		}, {});
		return dataBySymbol;
	}, {});
}

/**
 * @private
 * Combine data from multiple responses into one response object
 */
export function mergeResponses(responses) {
	return responses.reduce((mergedResponse, nextRawResponse) => {
		if (!mergedResponse.columns) mergedResponse.columns = nextRawResponse.columns;
		mergedResponse.rows = [ ...(mergedResponse.rows || []), ...nextRawResponse.rows];
		return mergedResponse;
	}, {});
}

export function toCsv(value) {
	return String(value && value.join ? value.join(',') : value).toUpperCase();
}
